export class LoginModel{
    username : any;
    password : any;
}